export default __webpack_public_path__ + "static/media/indexx all_black HD.5e067df7.png";